import type { RouteRecordRaw } from 'vue-router';

export const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('./pages/LoginPage.vue'),
  meta: {
    title: 'Sign In',
    layout: 'empty',
    public: true,
  },
};

export const magicLinkRoute: RouteRecordRaw = {
  path: '/magic-link',
  name: 'MagicLink',
  component: () => import('./pages/MagicLinkPage.vue'),
  meta: {
    title: 'Sign In',
    layout: 'empty',
    public: true,
  },
};

/**
 * Public on purpose: Google's OAuth consent screen links here, so it has to
 * open for someone who has never signed in — or whose session died.
 */
export const privacyRoute: RouteRecordRaw = {
  path: '/privacy',
  name: 'Privacy',
  component: () => import('./pages/PrivacyPolicyPage.vue'),
  meta: {
    title: 'Privacy Policy',
    layout: 'empty',
    public: true,
    anonymous: true,
  },
};

export const editMeRoute: RouteRecordRaw = {
  path: '/me/edit',
  name: 'EditMe',
  component: () => import('./pages/EditMePage.vue'),
  meta: {
    title: 'Edit Profile',
    layout: 'main',
  },
};

export const notificationSettingsRoute: RouteRecordRaw = {
  path: '/me/notifications',
  name: 'NotificationSettings',
  component: () => import('./pages/NotificationSettingsPage.vue'),
  meta: {
    title: 'Notification Settings',
    layout: 'main',
  },
};
